import { Injectable } from '@angular/core';
import { arrayNotEmpty, isEmpty } from 'class-validator';
import { BasicResponse } from 'src/app/core/models/basic-response.model';
import { getConnection } from 'src/app/core/services/functions.service';
import { QueriesService } from 'src/app/core/services/queries.service';
import { ModuloMenuSicfModel } from '../models/modulo-menu.model';

@Injectable({
  providedIn: 'root',
})
export class RolesService {
  private TABLA_PRINCIPAL: string = 'roles_sicf';
  private USUARIOS_ROLES: string = 'usuarios_roles_sicf';
  private MENU_ROLES: string = 'menu_roles_sicf';

  constructor(private queriesService: QueriesService) {}

  async findAll(): Promise<BasicResponse> {
    const result = await this.queriesService
      .table(this.TABLA_PRINCIPAL)
      .select(
        'codigo_rol as codigo',
        `descripcion_rol as descripcion`,
        'estado'
      )
      // .sql()
      .execute();
    return result;
  }

  async findAllByUser(usuario_aplicativo): Promise<BasicResponse> {
    const result = await this.queriesService
      .table(this.USUARIOS_ROLES)
      .select('codigo_usuario as usuario_aplicativo', 'codigo_rol as codigo')
      .where({ c_emp: getConnection(), codigo_usuario: usuario_aplicativo })
      .execute();
    return result;
  }

  async findOne(codigo: string): Promise<BasicResponse> {
    const result = await this.queriesService
      .table(this.TABLA_PRINCIPAL)
      .where({ codigo_rol: codigo })
      .execute();
    result.data = arrayNotEmpty(result.data) ? result.data[0] : null;
    return result;
  }

  async create(value: ModuloMenuSicfModel): Promise<BasicResponse> {
    const idResult = await this.queriesService
      .table(this.TABLA_PRINCIPAL)
      .select(`(TO_CHAR(MAX(${this.TABLA_PRINCIPAL}.codigo_rol)) + 1) as max`)
      .where("REGEXP_LIKE(codigo_rol, '^[[:digit:]]+$')")
      .execute();
    const id = Number(idResult.data[0].max);
    const result = await this.queriesService
      .table(this.TABLA_PRINCIPAL)
      .insert({ ...value, codigo_rol: id, c_emp: getConnection() })
      .execute();
    return result;
  }

  async update(value: any, where: any) {
    const result = await this.queriesService
      .table(this.TABLA_PRINCIPAL)
      .update(value, where, 1)
      .execute();
    return result;
  }

  async asignarOpciones(codigo_rol: string, opciones: any[]) {
    const readyOptions: {
      c_emp: string;
      codigo_rol: string;
      codigo_opcion: string;
      codigo_modulo: string;
    }[] = [];
    opciones.forEach((opcion) => {
      readyOptions.push({
        c_emp: getConnection(),
        codigo_rol,
        codigo_opcion: opcion.codigo,
        codigo_modulo: opcion.codigo_modulo,
      });
    });
    const result = await this.queriesService
      .table(this.MENU_ROLES)
      .insert(readyOptions)
      // .sql()
      .execute();
    return result;
  }

  async eliminarOpciones(codigo_rol: string, opciones: any[]) {
    const readyOptions: {
      c_emp: string;
      codigo_rol: string;
      codigo_opcion: string;
      codigo_modulo: string;
    }[] = [];
    opciones.forEach((opcion) => {
      readyOptions.push({
        c_emp: getConnection(),
        codigo_rol,
        codigo_opcion: opcion.codigo,
        codigo_modulo: opcion.codigo_modulo,
      });
    });
    const result = await this.queriesService
      .table(this.MENU_ROLES)
      .delete(readyOptions, readyOptions.length)
      .execute();
    return result;
  }

  async asignarRolesAlUsuario(
    usuario_aplicativo: string,
    codigos_roles: number[]
  ) {
    const result = this.queriesService
      .table(this.USUARIOS_ROLES)
      .insert(
        codigos_roles.map((val) => {
          return {
            c_emp: getConnection(),
            codigo_usuario: usuario_aplicativo,
            codigo_rol: val,
          };
        })
      )
      .execute();
    return result;
  }

  async eliminarRolesDelUsuario(
    usuario_aplicativo: string,
    codigos_roles: string[]
  ) {
    let where = '';
    codigos_roles.forEach((val) => {
      if (isEmpty(where)) {
        where = `CODIGO_USUARIO = '${usuario_aplicativo}' AND CODIGO_ROL = '${val}'`;
      } else {
        where += `OR CODIGO_USUARIO = '${usuario_aplicativo}' AND CODIGO_ROL = '${val}'`;
      }
    });
    const result = this.queriesService
      .table(this.USUARIOS_ROLES)
      .delete(where, codigos_roles.length)
      .execute();
    return result;
  }
}
